import React, { MutableRefObject, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { t } from "i18next";
import Loader from "../containers/loader";

interface Searchprops {
  handleEmptySearch: (args?: any) => Promise<void>;
  handleSearch: (args?: any) => Promise<void>;
  searchRef: MutableRefObject<string>;
  placeholder?: string;
  wrapperStyle?: string;
}

const SearchBar: React.FC<Searchprops> = ({
  handleEmptySearch,
  handleSearch,
  searchRef,
  placeholder,
  wrapperStyle,
}) => {
  const [search, setSearch] = useState(searchRef?.current);

  const [loading, setLoading] = useState(false);

  const SearhBarWrapper = "div";

  const onHandleSearchResult = async (
    event:
      | React.KeyboardEvent<HTMLInputElement>
      | React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    if (event.type === "keydown") {
      const keyboardEvent = event as React.KeyboardEvent<HTMLInputElement>;
      const target = keyboardEvent.target as HTMLInputElement; // Ensure target is HTMLInputElement

      console.log("Keyboard event value:", target.value);

      if (keyboardEvent.key === "Enter") {
        setLoading(true);

        handleSearch()?.finally(() => {
          setLoading(false);
        });
      }
      if (target.value === "") {
        console.log(
          "Input is already empty. Search function will not be called."
        );
        return;
      } else if (
        keyboardEvent.key === "Backspace" &&
        target.selectionStart === 0 && // No text is selected
        target.selectionEnd === target.value.length // Whole text is selected
      ) {
        setLoading(true);

        handleEmptySearch()?.finally(() => {
          setLoading(false);
        });
      } else if (
        keyboardEvent.key === "Backspace" &&
        target.value.trim().length === 1
      ) {
        setLoading(true);

        handleEmptySearch()?.finally(() => {
          setLoading(false);
        });
      }
    } else if (event.type === "click") {
      setLoading(true);

      handleEmptySearch()?.finally(() => {
        setLoading(false);
      });
    }
  };

  console.log("search", search);

  return (
    <SearhBarWrapper
      className={`${wrapperStyle ?? "relative rounded   my-2 flex  w-full shadow-sm lg:w-[50%]"} rounded shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)]`}
    >
      <input
        id="SearchBar"
        type="text"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setSearch(e?.target?.value);
          searchRef.current = e?.target?.value?.trim();
        }}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
          onHandleSearchResult(e)
        }
        value={search}
        className="relative m-0 block w-[1px] min-w-0 bg-hover dark:text-[white] flex-auto rounded rounded-r-none   bg-clip-padding px-3 py-[7px]  leading-[1.6]   transition duration-200 ease-in-out focus:z-[3] "
        placeholder={placeholder}
      />
      {loading ? (
        <span className="input-group-text flex items-center bg-hover  transition duration-200  whitespace-nowrap rounded rounded-l-none px-2 py-1 text-center  text-base text-primary cursor-pointer font-normal bg-[white]">
          <Loader size="sm" />
        </span>
      ) : search === "" ? (
        <span className="input-group-text flex items-center bg-hover  transition duration-200  whitespace-nowrap rounded rounded-l-none px-2 py-1 text-center  text-base text-primary cursor-pointer font-normal bg-[white]">
          <SearchIcon />
        </span>
      ) : (
        <span
          onClick={(e) => {
            setSearch("");
            searchRef.current = "";
            onHandleSearchResult(e);
          }}
          className="input-group-text flex items-center cursor-pointer bg-hover transition duration-200  whitespace-nowrap rounded rounded-l-none px-2 py-1 text-center  text-base font-normal bg-[white]
                   text-primary"
        >
          <CloseIcon />
        </span>
      )}
    </SearhBarWrapper>
  );
};

export default SearchBar;
